<!--
  CHAT-1068: the label and hint gaps are 6px and 4px, and Bootstrap's spacing
  utilities only offer 8px and 4px. `mb-2` is gone so .form-label's own 6px
  applies — the utilities carry !important, so while it was here the shared
  rule could never win. `mt-2` -> `mt-1` is the 4px hint gap. `mb-3` stays: it
  is already the 16px field gap.
-->
<ng-template #labelTemplate>
  <label *ngIf="props.label && props.hideLabel !== true"
         [attr.for]="id"
         class="form-label">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true"
          class="text-danger">*</span>
  </label>
</ng-template>
<div *ngIf="!props.hidden"
     class="mb-3"
     [class.form-floating]="props.labelPosition === 'floating'"
     [class.has-error]="showError">
  <ng-container *ngIf="props.labelPosition !== 'floating'">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  </ng-container>

  <ng-template #fieldComponent></ng-template>

  <ng-container *ngIf="props.labelPosition === 'floating'">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  </ng-container>

  <div *ngIf="showError"
       class="invalid-feedback"
       [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

  <small *ngIf="props.description"
         class="form-text text-muted mt-1 d-block"
         [innerHTML]="props.description">
  </small>
</div>
